module.exports = __webpack_public_path__ + "img/8_Proximal-T.47407426.png";